module.exports = __webpack_public_path__ + "static/media/Rahbar Branding.8fb74396.jpg";